<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('ContractManagement.contractId')">
                    <el-input
                      size="mini"
                      v-model="formInline.contractId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ContractManagement.supplierName')">
                    <el-input
                      size="mini"
                      v-model="formInline.supplierName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ContractManagement.isWarranty')">
                    <el-select
                      v-model="formInline.warrantyTime"
                      :placeholder="$t('ContractManagement.form.warrantyTimeTip')"
                      style="width: 180px"
                    >
                      <el-option :label="$t('common.search.whole')" value=""></el-option>
                      <el-option :label="$t('common.search.inWarranty')" value="0"></el-option>
                      <el-option :label="$t('common.search.outWarranty')" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('ContractManagement.signTime')">
                    <el-date-picker
                      v-model="formInline.signTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.search.dateSearch')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('CONTRACTMANAGEMENT_DELETE')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteContract"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('CONTRACTMANAGEMENT_ADD')" type="text" @click="addContract">{{$t('common.btn.add')}}</el-button>
                <el-button v-if="isPrimaryKey('CONTRACTMANAGEMENT_DOWNFILE')" type="text" @click="downFile()" :disabled="selected.length != 1">{{$t('common.btn.downloadFile')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="750px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="orgId"
            :label="$t('common.form.orgName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              disabled
              v-model="form.orgId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="contractId"
            :label="$t('ContractManagement.contractId')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.contractId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('ContractManagement.typeName')+':'"
            :label-width="formLabelWidth"
            prop="type"
          >
            <el-select v-model="form.type" :placeholder="$t('ContractManagement.typeName')">
              <el-option :label="$t('common.other')" value="0"></el-option>
              <el-option :label="$t('ContractManagement.form.sale')" value="1"></el-option>
              <el-option :label="$t('ContractManagement.form.buy')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="contractMoney"
            :label="$t('ContractManagement.contractMoney')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.contractMoney"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="signTime"
            :label="$t('ContractManagement.signTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.signTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="warrantyTime"
            :label="$t('ContractManagement.warrantyTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.warrantyTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="contactName"
            :label="$t('ContractManagement.contactName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.contactName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="phone"
            :label="$t('ContractManagement.phone')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="supplierName"
            :label="$t('ContractManagement.supplierName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.supplierName"
              autocomplete="off"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('common.remarks')+':'"
            :label-width="formLabelWidth"
            class="formStyle"
          >
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="form.remarks"
              autocomplete="off"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="filePath"
            :label="$t('common.btn.uploadFile')+':'"
            :label-width="formLabelWidth"
          >
            <input @change="uploadFile()" id="uploadDom" type="file" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{ $t("common.btn.cancel") }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{ $t("common.btn.confirm") }}</el-button>
        </div>
      </el-dialog>
       <el-dialog
        width="750px"
        :before-close="closeDetailsDia"
        class="carDialong"
        :title="$t('common.btn.detail')"
        :visible.sync="dialogDetailsFormVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="DetailsRorm" :model="DetailsRorm">
          <el-form-item
            prop="orgId"
            :label="$t('common.form.orgName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              disabled
              v-model="DetailsRorm.orgId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="contractId"
            :label="$t('ContractManagement.contractId')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="DetailsRorm.contractId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
          :label="$t('ContractManagement.typeName')+':'"
            :label-width="formLabelWidth"
            prop="type"
          >
            <el-select v-model="DetailsRorm.type" :placeholder="$t('ContractManagement.form.typeNameTip')">
              <el-option :label="$t('common.other')" value="0"></el-option>
              <el-option :label="$t('ContractManagement.form.sale')" value="1"></el-option>
              <el-option :label="$t('ContractManagement.form.buy')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="contractMoney"
            :label="$t('ContractManagement.contractMoney')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="DetailsRorm.contractMoney"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="signTime"
            :label="$t('ContractManagement.signTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="DetailsRorm.signTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="warrantyTime"
            :label="$t('ContractManagement.warrantyTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="DetailsRorm.warrantyTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="contactName"
            :label="$t('ContractManagement.contactName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="DetailsRorm.contactName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="phone"
            :label="$t('ContractManagement.phone')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="DetailsRorm.phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="supplierName"
            :label="$t('ContractManagement.supplierName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="DetailsRorm.supplierName"
              autocomplete="off"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('common.remarks')+':'"
            :label-width="formLabelWidth"
            class="formStyle"
          >
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="DetailsRorm.remarks"
              autocomplete="off"
              class="inputStyle"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ContractManagement from "./ContractManagement.js";
export default ContractManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

